import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Header, HeroCards } from ".";

export const HeroSection = () => {
    const intl = useIntl();

    const headerContent = {
        mainHeadingFirstPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.first-header-text",
            defaultMessage: "Great outcomes"
        }),
        mainHeadingSecondPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.second-header-text",
            defaultMessage: "start with Jira"
        }),
        subHeading: intl.formatMessage({
            id: "jira-product-tour.hero-header.sub-header-text",
            defaultMessage:
                "The only project management tool you need to plan and track work across every team."
        }),
        buttonText: intl.formatMessage({
            id: "jira-product-tour.hero-header.button-text",
            defaultMessage: "Get Jira Free"
        }),
        demoButtonText: intl.formatMessage({
            id: "jira-product-tour.hero-header.demo-button-text",
            defaultMessage: "Try a demo"
        })
    };

    const heroStyles = css({
        background: "#F4F5F7",
        width: "100%"
    });

    return (
        <div css={heroStyles}>
            <Header {...headerContent} />
            <HeroCards />
        </div>
    );
};

HeroSection.displayName = "HeroSection";
